import React from 'react';

import {
  HashRouter as Router,
  Route,
} from "react-router-dom";
import { AnimatedSwitch } from 'react-router-transition';

import './App.css';
import data from './data'
import Home from './views/Home';
import About from './views/About';
import Protocol from './views/Protocol';
import Playlist from './views/Playlist';
import Nav from './components/Nav';

const sequences = data.sequences.reduce((res, seq) => ({
  ...res,
  [seq.slug]: seq
}), {});

const toc = [
  {
    path: '/',
    component: Home,
    parameters: {
      title: 'Enquête sur EME'
    }
  },
  {
    path: '/protocol',
    component: Protocol,
    parameters: {
      title: 'Protocole et objectifs',
      data,
      sequences,
    }
  },
  ...data.persons.map((person, index) => ({
    path: `/sequence/${person.slug}`,
    component: Playlist,
    parameters: {
      title: `${person.firstName} ${person.familyName}`,
      subtitle: person.baselinefr,
      playlist: person.playlist,
      description: person.descfr,
      sequences: sequences
    }
  })),
  {
    path: '/a-propos/',
    component: About,
    parameters: {
      title: 'À propos'
    }
  }
];

function App() {
  return (
    <Router>
      <div className="container">
        <Nav toc={toc} />
        <AnimatedSwitch
          atEnter={{ 
            opacity: 0,
            top: (window.innerHeight)
          }}
          atLeave={{ 
            opacity: 0,
            top: -window.innerHeight
          }}
          atActive={{ 
            opacity: 1,
            top: 0
          }}
          className="switch-wrapper"
        >
          {
            toc.map((el, index) => {
              const Component = el.component;
              return (
                <Route 
                  key={index} 
                  exact 
                  path={el.path}
                  component={routerProps =>  <Component {...{...el.parameters, toc, routerProps}} />}
                >
                 
                </Route>
              )
            })
          }
        </AnimatedSwitch>
      </div>
    </Router>
  );
}

export default App;
